import React from 'react';
import { injectIntl } from 'react-intl';
import Logo from "../../assets/pilotly-logo-white-sm.png";
import { EnvType } from "./constants";
import svodMessages from '../../locales/svod';

class Footer extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		switch (this.props.environment) {
			case EnvType.PEACOCK:
				return (
					<footer id="end">
						<div>
							<span>{this.props.intl.formatMessage(svodMessages.terms_of_use)}</span>
							<span>{this.props.intl.formatMessage(svodMessages.privacy_policy)}</span>
							<span>{this.props.intl.formatMessage(svodMessages.ad_choices)}</span>
							<span>{this.props.intl.formatMessage(svodMessages.help)}</span>
							<span>{this.props.intl.formatMessage(svodMessages.do_not_sell_my_personal_information)}</span>
							<span>{this.props.intl.formatMessage(svodMessages.ca_notice)}</span>
						</div>
						<img src={Logo}></img>
					</footer>
				);
			case EnvType.APPLETV:
				return (
					<footer id="end">
						<span>{this.props.intl.formatMessage(svodMessages.pilotly_simulator)}</span>				
						<img src={Logo}></img>
					</footer>
				);
			default:
				return (
					<footer id="end">
						<img src={Logo}></img>
					</footer>
				);
		}
	}
}

export default (injectIntl(Footer));


// WEBPACK FOOTER //
// ./src/components/svod/footer.jsx